module.exports = __webpack_public_path__ + "static/img/cstSer_bg_03.4d69c503.svg";